'use client';

import styles from './Motability7SelectCarSection.module.scss';
import React, { useRef, useState } from 'react';
import Switch from './Switch/Motability7Switch';
import SelectedCarCarousel from './SelectedCarCarousel/Motability7SelectedCarCarousel';
import RightTopArrow from '../../../../assets/icons/right-top-arrow.svg';

const SelectCarSection = ({ data }) => {
  const swiperRef = useRef(null);
  const [selectedCarIndex, setSelectedCarIndex] = useState(0);
  const [selectedVersionIndex, setSelectedVersionIndex] = useState(0);

  // 确保 data 是数组
  const carData = Array.isArray(data) ? data : [];
  const selectedCar = carData[selectedCarIndex];
  const selectedVersion = selectedCar?.fields?.version?.[selectedVersionIndex];
  const { firstStageTitle, secondStageTitle } = selectedCar?.fields || {};

  const segmentedCarData = carData.map((item, index) => ({
    index,
    title: item.fields?.carName?.value?.toUpperCase() || '',
  }));

  const segmentedVersionData =
    selectedCar?.fields?.version?.map((item, index) => ({
      index,
      title: item.fields?.title?.value?.toUpperCase() || '',
    })) || [];

  const newCarouselData = carData.map((item, index) => {
    return {
      ...item,
      index: index,
    };
  });

  const [slideIndex, setSlideIndex] = useState(newCarouselData[0] || {});

  const handleClick = (idx) => {
    const newData = newCarouselData.find((el) => el.index === idx) ?? slideIndex;
    setSlideIndex(newData);
    setSelectedCarIndex(idx);
    swiperRef.current?.slideTo(idx);
  };

  const handleSegmentedClick = (index) => {
    setSelectedVersionIndex(index);
  };

  const handleLinkClick = (url) => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  if (!carData.length) {
    return <div>No car data available</div>;
  }

  return (
    <section>
      <div className={styles.firstStage} data-aos="fade-up">
        {firstStageTitle?.value && (
          <div dangerouslySetInnerHTML={{ __html: firstStageTitle.value }} />
        )}

        <div className={styles.selectCar}>
          <Switch items={segmentedCarData} activeIndex={selectedCarIndex} onClick={handleClick} />
        </div>
        <SelectedCarCarousel
          swiperRef={swiperRef}
          newCarouselData={newCarouselData}
          setSlideIndex={handleClick}
        />
      </div>
      <div className={styles.secondStage}>
        {segmentedVersionData.length > 1 && (
          <>
            {secondStageTitle?.value && (
              <div
                dangerouslySetInnerHTML={{ __html: secondStageTitle.value }}
                data-aos="fade-up"
              />
            )}
            <div className={styles.selectCar}>
              <Switch
                items={segmentedVersionData}
                activeIndex={selectedVersionIndex}
                onClick={handleSegmentedClick}
                data-aos="fade-up"
              />
            </div>
          </>
        )}

        <div className={styles.infoBlock} data-aos="fade-up">
          <div className={styles.infoTable}>
            <div className={styles.infoRow}>
              <div className={styles.label}>Advance Payment</div>
              <div className={styles.value}>
                {selectedVersion?.fields?.advancePayment?.value || ''}
              </div>
            </div>
            <div className={styles.infoRow}>
              <div className={styles.label}>For detailed information please click here</div>
              {selectedVersion?.fields?.detailedInformationLink?.value?.href && (
                <a
                  href={selectedVersion.fields.detailedInformationLink.value.href}
                  className={styles.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {selectedVersion?.fields?.detailedInformationText?.value || ''}
                </a>
              )}
              <img src={RightTopArrow} alt="Right Top Arrow icon" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SelectCarSection;
